// Meta Pixel (browser side). Loads only on the LMS marketing site after the visitor accepts the consent banner;
// every event carries an eventID that the backend re-uses for the Conversions API so Meta deduplicates the pair.
import { isMainHost } from "./hosts";

export const PIXEL_ID = process.env.REACT_APP_META_PIXEL_ID || "";
const CONSENT_KEY = "buma:consent";
const PRIVATE_PREFIXES = ["/backoffice", "/trainer", "/home", "/projects", "/lesson", "/activity", "/assignment", "/game", "/sandbox", "/staff-login", "/login", "/register", "/reset-password", "/forgot-password"];

export const getConsent = () => { try { return localStorage.getItem(CONSENT_KEY); } catch { return null; } };
export const setConsent = (v) => { try { localStorage.setItem(CONSENT_KEY, v); } catch { /* ignore */ } if (v === "granted") loadMetaPixel(); };
export const isMarketingPath = (path) => !PRIVATE_PREFIXES.some((p) => path === p || path.startsWith(p + "/") || path.startsWith(p));
export const pixelEnabled = () => !!PIXEL_ID && isMainHost() && getConsent() === "granted";

export function loadMetaPixel() {
  if (typeof window === "undefined" || window.__bumaPixel || !PIXEL_ID || !isMainHost()) return;
  window.__bumaPixel = true;
  if (!window.fbq) {
    const n = (window.fbq = function () { n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments); });
    n.push = n; n.loaded = true; n.version = "2.0"; n.queue = [];
    const s = document.createElement("script");
    s.async = true; s.src = "https://connect.facebook.net/en_US/fbevents.js";
    document.head.appendChild(s);
  }
  window.fbq("init", PIXEL_ID);
}

export const eventId = () => `${(window.crypto?.randomUUID?.() || Math.random().toString(36).slice(2))}-${Date.now()}`;
const cookie = (name) => document.cookie.split("; ").find((c) => c.startsWith(name + "="))?.split("=")[1] || null;

// Payload the backend needs to mirror an event server-side (same event_id → Meta deduplicates browser + server).
export const prepare = () => ({ event_id: eventId(), fbp: cookie("_fbp"), fbc: cookie("_fbc"), url: window.location.href, consent: getConsent() === "granted" });
// Fires the browser event once the server confirmed the action succeeded.
export const fire = (name, params = {}, meta) => { if (pixelEnabled() && window.fbq) window.fbq("track", name, params, { eventID: meta?.event_id || eventId() }); };
export function track(name, params = {}) { const m = prepare(); fire(name, params, m); return m; }

export const pageView = (id = eventId()) => { if (pixelEnabled() && window.fbq) window.fbq("track", "PageView", {}, { eventID: id }); };
